import React, { useContext, useEffect, useState } from "react";
import "../Components/Assets/css/newStyle.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { MyContext } from "./Context/SharedStateContext";
import WhatsApp from "../../Components/assets/img/WhatsApp.svg";
import {
  LayoutDashboard,
  Inbox,
  HelpCircle,
  Users,
  Settings,
  LogOut,
} from "lucide-react";

const NewSidebar = () => {
  const navigate = useNavigate();
  const { isSidebarOpen, setIsSidebarOpen, isSidebarMinimized } =
    useContext(MyContext);
  const tenantName = localStorage.getItem("tenantName");

  const location = useLocation(); // To track the current route
  const [activePath, setActivePath] = useState(location.pathname);

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  useEffect(() => {
    if (!tenantName) {
      navigate("/login");
    }
  }, [tenantName, navigate]);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    localStorage.removeItem("tenantName");
    localStorage.removeItem("shopURL");
    localStorage.removeItem("isWidget");
    localStorage.removeItem("tenantEmail");
    setIsSidebarOpen((prev) => !prev);
    navigate("/login");
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const handleNavClick = (path) => {
    setActivePath(path);
    setIsSidebarOpen((prev) => !prev);
  };

  // Update the class on the body element whenever `isSidebarMinimized` changes
  useEffect(() => {
    if (isSidebarMinimized) {
      document.body.classList.add("sidebar-icon-only");
    } else {
      document.body.classList.remove("sidebar-icon-only");
    }
  }, [isSidebarMinimized]);

  return (
    <nav
      className={`chat-sidebar sidebar-offcanvas ${
        isSidebarOpen ? "active" : ""
      }`}
      id="sidebar"
    >
      <ul className="nav">
        <li
          className={`nav-item ${
            activePath.includes("/dashboard") ? "active" : ""
          }`}
        >
          <Link
            to={`/${tenantName}/chat/dashboard`}
            className="chat-nav-link"
            onClick={() => handleNavClick("/dashboard")}
          >
            <span className="icon-bg">
              {/* <i className="mdi mdi-cube menu-icon"></i> */}
              <LayoutDashboard size={18} />
            </span>
            <span className="menu-title">Dashboard</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            activePath.includes("/Conversation") ||
            activePath.includes("/tickets")
              ? "active"
              : ""
          }`}
        >
          <Link
            to={`/${tenantName}/chat/Conversation/Unassigned/:collection`}
            className="chat-nav-link"
            onClick={() => handleNavClick("/Conversation")}
          >
            <span className="icon-bg">
              {/* <i className="mdi mdi-email-open menu-icon"></i> */}
              <Inbox size={18} />
            </span>
            <span className="menu-title">Inbox</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            activePath.includes("/faq-bot") ? "active" : ""
          }`}
        >
          <Link
            to={`/${tenantName}/chat/faq-bot`}
            className="chat-nav-link"
            onClick={() => handleNavClick("/faq-bot")}
          >
            <span className="icon-bg">
              {/* <i className="mdi mdi-help-circle menu-icon"></i> */}
              <HelpCircle size={18} />
            </span>
            <span className="menu-title">FAQ</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            activePath.includes("/contact") ? "active" : ""
          }`}
        >
          <Link
            to={`/${tenantName}/chat/contact`}
            className="chat-nav-link"
            onClick={() => handleNavClick("/contact")}
          >
            <span className="icon-bg">
              {/* <i className="mdi mdi-contacts menu-icon"></i> */}
              <Users size={18} />
            </span>
            <span className="menu-title">Contacts</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            activePath.includes("/Setting") ? "active" : ""
          }`}
        >
          <Link
            to={`/${tenantName}/chat/Setting/Appearance`}
            className="chat-nav-link"
            onClick={() => handleNavClick("/Setting")}
          >
            <span className="icon-bg">
              {/* <i className="mdi mdi-brightness-5 menu-icon"></i> */}
              <Settings size={18} />
            </span>
            <span className="menu-title">Settings</span>
          </Link>
        </li>
        <li
          className={`nav-item ${
            activePath.includes("/logout") ? "active" : ""
          }`}
        >
          <a className="chat-nav-link" href="#" onClick={handleLogoutClick}>
            <span className="icon-bg">
              {/* <i className="mdi mdi-power menu-icon"></i> */}
              <LogOut size={18} />
            </span>
            <span className="menu-title">Logout</span>
          </a>
        </li>
      </ul>
      <a
        className="whats-app"
        href="https://wa.me/918925696660"
        target="_blank"
        rel="noreferrer"
        data-toggle="tooltip"
        data-placement="left"
        title="WhatsApp Support"
      >
        <img
          src={WhatsApp}
          className="img-fluid whatsapp-icon"
          alt="whats-app"
        />
      </a>
      {showLogoutModal && (
        <div className="chatbot-logout-modal-backdrop">
          <div className="chatbot-logout-modal-container fade show">
            <div className="chatbot-logout-modal-dialog">
              <div className="chatbot-logout-modal-content">
                <div className="chatbot-logout-modal-header">
                  <h5 className="chatbot-logout-modal-title">Confirm Logout</h5>
                  <button
                    type="button"
                    className="chatbot-logout-modal-close-btn"
                    onClick={handleCancelLogout}
                    aria-label="Close"
                  >
                    &times;
                  </button>
                </div>
                <div className="chatbot-logout-modal-body">
                  <p>Are you sure you want to log out of your account?</p>
                </div>
                <div className="chatbot-logout-modal-footer">
                  <button
                    type="button"
                    className="chatbot-logout-modal-cancel-btn"
                    onClick={handleCancelLogout}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="chatbot-logout-modal-confirm-btn"
                    onClick={handleConfirmLogout}
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NewSidebar;
